import React, { useState, useEffect } from 'react';
import { Card, Badge, Spinner, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import AICoachService from './AICoachService';
import Cookies from 'js-cookie';
const AICoachCard = () => {
  const [summary, setSummary] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    setIsLoading(true);
    const aiCoachValue = Cookies.get('aiCoach');
    if (!aiCoachValue) {
      AICoachService.retrieveSummaryByProfile().then(data => {
        setSummary(data);
        console.log(data);
        Cookies.set('aiCoach', JSON.stringify(data), { expires: 7, sameSite: 'lax' });
        setIsLoading(false);
      });
    } else {
      setSummary(JSON.parse(aiCoachValue));
      setIsLoading(false);
    }
  }, []);

  return (
    <>
      {isLoading ? (
        <>
          <Modal.Header closeButton>
            <Modal.Title>Loading Ai Coach...</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center py-5">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Modal.Body>
        </>
      ) :
        summary && (
          <Card className="h-100 border-0 shadow-sm text-white"
            style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
            }}>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-start mb-3">
                <div className="d-flex align-items-center">
                  <div
                    className="rounded-circle bg-white bg-opacity-25 d-flex align-items-center justify-content-center me-2"
                    style={{ width: '40px', height: '40px' }}
                  >
                    <FontAwesomeIcon icon={faBrain} className="text-white" />
                  </div>
                  <div>
                    <h5 className="mb-0 fw-bold">AI Coach Insights</h5>
                    <small className="text-white-75">Weekly Summary</small>
                  </div>
                </div>
                <Badge bg="light" text="dark" className="d-flex align-items-center">
                  <FontAwesomeIcon icon={faArrowUp} className="me-1" size="xs" />
                  Score: {summary?.score}
                </Badge>
              </div>

              <p className="text-white mb-3">{summary?.weekSummary}</p>

              <div className="d-flex flex-column gap-2">
                {summary?.insights.map((insight, index) => (
                  <div
                    key={index}
                    className="p-2 rounded d-flex align-items-start"
                    style={{ backgroundColor: 'rgba(255,255,255,0.15)' }}
                  >
                    <span className="me-2">{insight.icon}</span>
                    <small className="text-white">{insight.message}</small>
                  </div>
                ))}
              </div>
            </Card.Body>
          </Card>
        )}
    </>
  );
};

export default AICoachCard;
